import * as React from "react";

const Checkbox = (props: any) => (
  <svg width={64} height={64} viewBox="0 0 64 64" {...props}>
    <g fill="none" fillRule="evenodd">
      <path fill="#D2D5D8" d="M8 24h16v16H8z" />
      <path
        d="M30 32h24"
        stroke="#7B838C"
        strokeWidth={4}
        strokeLinecap="round"
      />
      <path d="M10 26v12h12V26H10z" stroke="#7B838C" strokeWidth={4} />
      <path
        d="M18 31l-1.853 1.853a.208.208 0 0 1-.293 0L14 31"
        stroke="#7B838C"
        strokeWidth={2}
      />
    </g>
  </svg>
);

export default Checkbox;

